import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { EditGoToTestTT } from 'features/cabinet/tiktok';
import { Guard, usePermissionGuard } from 'features/login';

const EditGoToTestPage: FC = () => {
  const { accessToChangeTiktokgototest } = usePermissionGuard();
  return (
    <Guard hasAccess={accessToChangeTiktokgototest}>
      <CabinetTitlePage
        title={'Go To Test'}
        goBack={'/cabinet/tiktok/go-to-test'}
      />
      <EditGoToTestTT />
    </Guard>
  );
};

export default EditGoToTestPage;
